import React, { useState, useEffect, useRef } from 'react'
import LayoutStyle from './LayoutStyle'
import DrawerMenu from '../DrawerMenu'
import { Bell } from 'lucide-react'
import { get } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FaSignOutAlt } from 'react-icons/fa'
import { Drawer, notification } from 'antd'
import api, { customFuncsApi } from '../../api'
import moment from 'moment'
import DeleteTask from '../Modal/DeleteTask'
import { undiruvchiList } from '../../store/slices'

const Layout = ({ children }) => {
	const { getMe } = useSelector((state) => state.main)
	const navigate = useNavigate()
	const deleteRef = useRef()
	const dispatch = useDispatch()
	const { setValue: setUndiruvchiListValue } = undiruvchiList.actions

	const [clicked, setClicked] = useState(false)
	const [notFinished, setNotFinished] = useState([])
	const [isLoadingNotFinished, setIsLoadingNotFinished] = useState(false)
	const [isOpenBell, setIsBellOpen] = useState(false)
	const [executors, setExecutors] = useState([])

	useEffect(() => {
		getAllGetterMoney()
	}, [])

	const getAllGetterMoney = () => {
		api
			.get(
				`$crossjoin(EmployeesInfo, Departments)?$filter=(Departments/Name eq 'Undiruv' or Departments/Name eq 'Undiruvchi1' or Departments/Name eq 'Undiruvchi3' or Departments/Name eq 'Undiruvchi2') and EmployeesInfo/Department eq Departments/Code&$expand=EmployeesInfo($select=EmployeeID,LastName,FirstName,U_CashAccount,U_CardAccount,U_TransAccount),Departments($select=Name,Code)`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=90000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				dispatch(setUndiruvchiListValue(resData))
				if (get(getMe, 'Department2.Name', '') === 'Undiruv') {
					const data = resData.filter(
						(v) => v.EmployeesInfo.EmployeeID === get(getMe, 'EmployeeID', ''),
					)
					setExecutors(data)
				} else setExecutors(resData)
			})
			.catch((err) => {
				// errorRef.current?.open(
				// 	get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
	}

	const getNotFinishedDuner = () => {
		setIsLoadingNotFinished(true)
		const url = `xsSql/getTasks`
		const params = {
			deadLineStartDate: '',
			deadLineEndDate: moment().add(1, 'day').format('YYYY-MM-DD'),
			dunnerId:
				get(getMe, 'Department2.Name', '') === 'Boshqaruv'
					? ''
					: get(getMe, 'EmployeeID', ''),
			hasTask: 'Y',
			isProved: 'Yes',
			dunnerStatus: 'NotYet',
			$skip: 0,
		}

		customFuncsApi
			.get(url, {
				params,
			})
			.then((res) => {
				const resData = res.data.value
				const now = moment()
				const deadlineFiltered = resData.filter(
					(v) =>
						moment(v.U_DeadLine, 'YYYY-MM-DD HH:mm:ss').isBefore(
							now,
							'minute',
						) ||
						moment(v.U_DeadLine, 'YYYY-MM-DD HH:mm:ss').isSame(now, 'minute'),
				)
				setNotFinished(deadlineFiltered)
				setIsLoadingNotFinished(false)

				deadlineFiltered.forEach((task) => {
					if (
						moment(task.U_DeadLine, 'YYYY-MM-DD HH:mm:ss').isSame(now, 'minute')
					) {
						console.log(now.format('YYYY-MM-DD HH:mm:ss'))
						notification.info({
							message: `Задача с IMEI ${task.IntrSerial} просрочена!`,
							description: `Задача с дедлайном ${task.U_DeadLine} просрочена!`,

							placement: 'topRight',
							duration: 0,
							showProgress: true,
							pauseOnHover: false,
							onClick: () => {
								viewTask(task)
							},
						})
					}
				})
			})
			.catch((err) => {
				setIsLoadingNotFinished(false)
				notification.error({
					message: `${err.respose.data.message}`,
					description: 'Failed to fetch tasks.',
					placement: 'topRight',
				})
			})
	}

	useEffect(() => {
		getNotFinishedDuner()
		const intervalId = setInterval(getNotFinishedDuner, 60 * 1000)

		return () => clearInterval(intervalId)
	}, [])

	const handleClick = () => {
		navigate('/login', { replace: true })
	}

	const handleClose = () => {
		setClicked(false)
	}

	const viewTask = (v) => {
		deleteRef.current?.open(v)
		setClicked(false)
		setIsBellOpen(false)
	}

	return (
		<LayoutStyle>
			<DrawerMenu />
			<div className="flex flex-col">
				<div className="relative flex h-[80px] w-full items-center justify-end gap-4 bg-[#FFFFFF] pr-10 drop-shadow-xl">
					<div className="flex items-center gap-5">
						<div>
							<Bell
								size={20}
								color="#0085FF"
								onClick={() => setIsBellOpen(!isOpenBell)}
							/>
							<Drawer
								title={
									get(getMe, 'FirstName', '') + ' ' + get(getMe, 'LastName', '')
								}
								onClose={() => setIsBellOpen(false)}
								className="w-full"
								open={isOpenBell}
							>
								<div className="flex flex-col gap-2">
									{notFinished.map((item) => (
										<div
											className="flex flex-col  bg-gray-200 p-2 rounded-lg"
											onClick={() => viewTask(item)}
										>
											<span className="font-bold">{`Задача с IMEI ${item.IntrSerial} просрочена!`}</span>
											<span className="mt-2">{`Задача с дедлайном ${item.U_DeadLine} просрочена!`}</span>
											<span>{`Приемщик: ${item.DunnerLastName} ${item.DunnerName}`}</span>
										</div>
									))}
								</div>
							</Drawer>
						</div>
						<div
							className="flex items-center gap-2"
							onClick={() => setClicked(true)}
						>
							<div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0085FF1A] text-[#0085FF]">
								{get(getMe, 'FirstName', '')[0]}
							</div>
							<h1 className="font-inter text-base font-medium">
								{get(getMe, 'FirstName', '') + ' ' + get(getMe, 'LastName', '')}
							</h1>
						</div>
						<Drawer
							title={
								get(getMe, 'FirstName', '') + ' ' + get(getMe, 'LastName', '')
							}
							onClose={handleClose}
							open={clicked}
						>
							<div className="flex flex-col justify-between h-full">
								<div className="flex flex-col gap-2">
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Доллар касса</span>
										<span>{get(getMe, 'U_CashAccount', '')}</span>
									</div>
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Сум касса</span>
										<span>{get(getMe, 'U_CashUzsAccount', '')}</span>
									</div>
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Карта</span>
										<span>{get(getMe, 'U_CardAccount', '')}</span>
									</div>

									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Терминал</span>
										<span>{get(getMe, 'U_TerminalAccount', '')}</span>
									</div>
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Транзит касса</span>
										<span>{get(getMe, 'U_TransAccount', '')}</span>
									</div>

									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Склад</span>
										<span>{get(getMe, 'U_Warehouse', '')}</span>
									</div>
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Должность</span>
										<span>{get(getMe, 'Department2.Name', '')}</span>
									</div>
								</div>
								<button
									className="mt-4 flex w-full items-center justify-center gap-2 rounded bg-red-500 p-2 text-white"
									onClick={handleClick}
								>
									Выход <FaSignOutAlt />
								</button>
							</div>
						</Drawer>
					</div>
				</div>
				{children}
			</div>
			<DeleteTask
				getRef={(r) => {
					deleteRef.current = r
				}}
				onClose={() => {
					getNotFinishedDuner()
				}}
				executer={executors}
			/>
		</LayoutStyle>
	)
}

export default Layout
